import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b289bd60"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hand" }
const _hoisted_2 = { class: "handcardparent" }

import Card from "@/model/Card";
import { computed } from "vue";
import CardComponent from "./CardComponent.vue";
import { store } from "@/main";


export default /*#__PURE__*/_defineComponent({
  __name: 'HandComponent',
  props: {
    cards: Array,
},
  setup(__props) {



const play = (card: Card) => {
    //   const game = store.game;
    //   if (game.getStage() === GameStage.STOCK && game.getPlaying()) {
    //     store.table.hand = store.table.hand.filter((c) => card.id !== c.id);
    //     store.table.stock.push(card);
    //   }
    //   if (game.getStage() === GameStage.SPIEL) {
    //     store.table.hand = store.table.hand.filter((c) => card.id !== c.id);
    //     if (game.getTurn()) this.playCard(card);
    //     else window.alert("Du bist nicht dran!");
    //   }
    store.game.onHandCardSelect(card)
};

const handSorted = computed(() => {
    if (store.table.hand === undefined) return []
    return store.table.hand.sort(higher)
})

const higher = (a: Card, b: Card) => {
    // Buben
    if (a.getValue() === "J") {
        if (b.getValue() === "J") return a.getSuitNumber() > b.getSuitNumber() ? 1 : -1
        return 1
    }
    if (b.getValue() === "J") {
        if (a.getValue() === "J") return a.getSuitNumber() > b.getSuitNumber() ? 1 : -1
        return -1
    }
    if (a.getSuitNumber() > b.getSuitNumber()) return 1
    else if (a.getSuitNumber() < b.getSuitNumber()) return -1
    else {
        if (a.getValueNumber() > b.getValueNumber()) return 1
        else if (a.getValueNumber() < b.getValueNumber()) return -1
        else return 0
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(handSorted), (card, index) => {
        return (_openBlock(), _createBlock(CardComponent, {
          key: card.id,
          id: card.id,
          index: index,
          rotate: false,
          animate: true,
          onClick: ($event: any) => (play(card))
        }, null, 8, ["id", "index", "onClick"]))
      }), 128))
    ])
  ]))
}
}

})